import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import AutoOrderFilter from './AutoOrderFilter';
import AutoOrderTable from './AutoOrderTable';

export const autoOrderBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'analytics',
    url: '/analytics/autoorder'
  },

  {
    label: 'auto_order',
    active: true
  }
];

const AutoOrder = () => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState(false);
  return (
    <div>
      <PageBreadcrumb items={autoOrderBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('auto_order')}</h2>

        <AutoOrderFilter setTableData={setTableData} />
        <AutoOrderTable tableData={tableData} />
      </div>
    </div>
  );
};

export default AutoOrder;
